/**
 * A global namespace for `pointerup` event.
 */
const pointerupEvent = 'pointerup';
export default pointerupEvent;
